import React, { useState, useEffect, useCallback } from "react";
import { downloadPeopleRequest } from "../api/request/request-api";

export const peopleRequestHandle = 
    (
        userId, 
        userServiceCategory, 
        peopleRequestIncrementSize, 
        peopleRequestLowerLimit, 
        userCountryName, 
        userLatitude, 
        userLongitude, 
        distanceUnit, 
        radius, 
        isNoPeopleRequest,
        setIsNoPeopleRequest,
        setIsLoadingPeopleRequests, 
        requestPeopleArray, 
        setRequestPeopleArray, 
        setIsShowMorePeopleRequest, 
        setErrorContent, 
        setIsSystemError, 
        setPeopleRequestLowerLimit, 
        setIsPeopleRequestRefresh, 
        userAccountType, 
        isPeopleRequestRefresh
        
    ) => {
    
    const getPeopleRequests = useCallback(async () => {
        return new Promise(async(resolve, reject) => {
            try {
                let response = await downloadPeopleRequest(userId, userServiceCategory, peopleRequestIncrementSize, peopleRequestLowerLimit, userCountryName, userLatitude, userLongitude, distanceUnit, radius);
                setIsLoadingPeopleRequests(false);
                if (requestPeopleArray.length === 0 || peopleRequestLowerLimit === 0) {
                    if(response.length > 0){
                        setRequestPeopleArray(response);
                        if (response.length < peopleRequestIncrementSize) {
                            setIsShowMorePeopleRequest(false);
                        }
                    } else {
                        setRequestPeopleArray([]);
                        setIsNoPeopleRequest(true);
                    }
                } else {
                    let newItemCount = response.length;
                    setRequestPeopleArray(requestPeopleArray => [...requestPeopleArray, ...response]);
                    if (newItemCount < peopleRequestIncrementSize) {
                        setIsShowMorePeopleRequest(false);
                    }
                }
                resolve("success")
            } catch (error) {
                console.log(error);
                // setErrorContent({ 'header': "Error getting people requests", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" });
                // setIsSystemError(true);
                setIsLoadingPeopleRequests(false);
                reject("failed")
            }
        })
    },[userId, userServiceCategory, peopleRequestIncrementSize, peopleRequestLowerLimit, userCountryName, userLatitude, userLongitude, distanceUnit, radius])

    const refreshPeopleRequest = useCallback(() => {
        return new Promise((resolve, reject) => {
            setIsShowMorePeopleRequest(true);
            setPeopleRequestLowerLimit(0);
            setIsPeopleRequestRefresh(true);
            resolve("success");
        });
    },[])

    // for refresh
    useEffect(() => {
        if (!isPeopleRequestRefresh)
            return;
        setIsPeopleRequestRefresh(false);
        if (userAccountType == "Professional" || userAccountType == "Employee") {
            getPeopleRequests();
        }
    }, [isPeopleRequestRefresh]);
    
    //change in radius
    useEffect(() => {
        if (!radius)
            return;
        refreshPeopleRequest();
    }, [radius]);

    return { refreshPeopleRequest, getPeopleRequests };
}
